// Polyfill
import './polyfill/_assign'
import './polyfill/_entries'
import './polyfill/_isnan'
import './polyfill/_repeat'
import './polyfill/_for-each'

// Import modules
import Navigation from './modules/_navigation'
import Objectfit from './modules/_object-fit'
import Print from './modules/_print'
import Lotti from './modules/_lotti'
import MegaMenu from './modules/_mega-menu'
import Articles from './modules/_articles'
import AllFeatures from './modules/_all-features'
import VideoModal from './modules/_video-modal'
import SocialShare from './modules/_social-share'
import StickyPolyfill from './modules/_sticky'
import GraphSlider from './modules/_graph-slider'
import FloatingLabels from './modules/_floating-labels'
import Accordion from './modules/_accordion'
import ReviewSlider from './modules/_review-slider'
import CardSlider from './modules/_card-slider'
import Newsroom from './modules/_newsroom'
import FeatureSlider from './modules/_feature-slider'
import Scroll from './modules/_scroll'
import ItemCounter from './modules/_item-counter'
import EmployeeSlider from './modules/_employee-slider'
import FeaturesOverview from './modules/_features-overview'
import TestimonialSlider from './modules/_testimonial-slider'
import TextCodeBlock from './modules/_text-code-block'
import ContactForm from './modules/_contact-form'
import startAnimations from './modules/_start-animations'
import ImageTextCardSlider from './modules/_image-text-card-slider'
import ttmZeroCircle from './modules/_ttmzero-circle'
import TextVideo from './modules/_text-video'
import Hubspot from './modules/_hubspot'
import LoadMore from './modules/_load-more'
import VideoSection from './modules/_video-section'
import FairXchangeNavigation from "./modules/_fairxchange-navigation";
import AthenaCoverAnimations from "./modules/_athena-cover";
import JobOffers from "./modules/_job-offers";
import AllProducts from "./modules/_all-products";
import Knowledgehub from "./modules/_knowledgehub";
import AllSolutions from "./modules/_all-solutions";
import MegaMenuSolutions from "./modules/_mega-menu-solutions";
import TextLinkBoxesMatchHeight from 'modules/_text-link-boxes-matchheight'
import ReviewShuffle from 'modules/_reviews-shuffle'
import FeatureCardMatchHeight from "./modules/_feature-card-matchheight";
import KnowledgehubCardMatchHeight from "./modules/_knowledgehub-card-matchheight";
import LogoSlider from "./modules/_logo-slider";
import Parallax from "./modules/_parallax";

Navigation()
Objectfit()
Print()
Lotti()
MegaMenu()
Articles()
AllFeatures()
VideoModal()
SocialShare()
StickyPolyfill()
GraphSlider()
Accordion()
ReviewSlider()
CardSlider()
Newsroom()
FeatureSlider()
Scroll()
EmployeeSlider()
FeaturesOverview()
TestimonialSlider()
TextCodeBlock()
ContactForm()
ImageTextCardSlider()
Hubspot()
LoadMore()
VideoSection()
FairXchangeNavigation()
JobOffers()
AllProducts()
Knowledgehub()
AllSolutions()
MegaMenuSolutions()
TextLinkBoxesMatchHeight()
FeatureCardMatchHeight()
KnowledgehubCardMatchHeight()
ReviewShuffle()
LogoSlider()
Parallax()

window.addEventListener('load', () => {
  require('./app')
  ItemCounter()
  ttmZeroCircle()
  startAnimations()
  FloatingLabels()
  AthenaCoverAnimations()
  TextVideo()
})
